<template lang="pug">
.dawn-attention-box-wrapper
  .title-area
    h1.box-title {{ title }}
    p.page-subtitle(v-if='subtitle') {{ subtitle }}
  .dawn-attention-box
    slot
</template>

<script>

export default {
  name: 'ed-box',
  props: {
    title: String,
    subtitle: String
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-attention-box-wrapper {

  margin: 1rem 0rem .5rem 0rem;

  .dawn-attention-box {
    background: $background-light;
    border: $border-width-default solid;
    border-color: $background;
    border-radius: $border-radius;
    padding: 1rem;
  }

  h1.box-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: .5rem;
    color: $ink;
    font-weight: $font-weight-bold;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?1bfe958e